module.exports = __webpack_public_path__ + "img/client-irwin.c075d94f.png";